var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckVerified02 = function SvgCheckVerified02(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m8.812 21.865-1.785-3.007-3.388-.743.33-3.488L1.673 12 3.97 9.373l-.33-3.488 3.388-.743 1.785-3.007L12 3.489l3.189-1.354 1.784 3.007 3.389.743-.331 3.488L22.327 12l-2.296 2.627.33 3.488-3.388.743-1.784 3.007L12 20.512zm.638-1.915L12 18.87l2.58 1.08 1.42-2.4 2.75-.63-.25-2.82 1.85-2.1-1.85-2.13.25-2.82-2.75-.6-1.45-2.4L12 5.13 9.42 4.05 8 6.45l-2.75.6.25 2.82L3.65 12l1.85 2.1-.25 2.85 2.75.6zm1.5-4.746L16.254 9.9 15.2 8.816l-4.25 4.25-2.15-2.12L7.746 12z"
  })));
};
export default SvgCheckVerified02;